// ============================================================================
// @orgazone/core-catalog — LA NATURE D'UN ARTICLE : marchandise, prestation, titre.
// UTILITÉ : ce qu'on vend n'est pas toujours une marchandise. Une PRESTATION (une retouche) ne consomme
// aucune marchandise : ni stock, ni coût d'achat. Un TITRE (chèque cadeau, acompte) est de l'argent encaissé
// d'avance, qui devient du chiffre quand il paie des articles. Une seule liste, lue par le siège, ses écrans
// et la caisse.
// ⚠️ LISTE FERMÉE ET PERSISTÉE (`article.item_kind`), qui voyage vers la flotte : une valeur se migre, elle ne
//    se renomme jamais.
// ⚠️ UNE TABLE À PART POUR LES PRESTATIONS A ÉTÉ ÉCARTÉE (décision utilisateur) : comme dans les logiciels du
//    marché, la main-d'œuvre est séparée à l'affichage, pas dans le catalogue — ce qui vit à part, c'est le
//    dossier de travail (la fiche d'atelier `service`).
// ============================================================================

/** Les natures, dans l'ordre où un écran les propose. */
export const ITEM_KINDS = ['goods', 'service', 'title'] as const;
export type ItemKind = (typeof ITEM_KINDS)[number];

/** La nature d'un article dont personne n'a rien dit : une marchandise. */
export const DEFAULT_ITEM_KIND: ItemKind = 'goods';

/** Cette valeur est-elle une nature connue ? Une valeur hors liste ne serait comprise par aucune règle. */
export const isItemKind = (v: unknown): v is ItemKind => typeof v === 'string' && (ITEM_KINDS as readonly string[]).includes(v);

/**
 * Cette nature peut-elle être suivie en stock ? Seule une marchandise : une prestation et un titre n'ont rien à
 * compter, et suivis en stock ils partiraient en négatif à chaque vente, dans les inventaires et les écarts.
 */
export const isStockableKind = (kind: ItemKind): boolean => kind === 'goods';
